import {adEventKey} from '@app/components/ads/hooks/use-ad-event'
import EventType from './event-type'

const EventKey = {
  totalGamesActive: 'total-games-active',
  countOfGamesShown: 'count-of-games-shown',
  gameName: 'game-name',
  gameCode: 'game-code',
  playCount: 'plays-count',
  gameCategory: 'game-category',
  gameCardPosition: 'game-card-position',
  gameFavouriteStatus: 'action',
  gameCountInCategory: 'count-of-games-in-category',
  pageNumber: 'page-number',
  fromPageNumber: 'from-page-number',
  favorite: 'favorite',
  toPageNumber: 'to-page-number',
  // totalAvailablePages: 'total-available-pages',
  fromLang: 'from-lang',
  toLang: 'to-lang',
  title: 'title',
  url: 'url',
  isFeaturedGame: 'is-featured-game',
  searchString: 'search-string',
  scrollPercentage: 'scroll-percentage',
  ratingGiven: 'rating_given',
  countOfGamesAvailable: 'count-of-games-available',
  pageName: 'page-name',
  category: 'category-name',
  layout: 'layout-name',
  activeLanguage: 'active-langauge',
  languageSelected: 'selected-language',
  gameOrientation: 'game-orientation',
  loadTime: 'load-time',
  adSlot: 'ad-slot',
  adSize: 'ad-size',
} as const

const blacklistedAdsEvents = [
  'ad-requested',
  'ad-viewed',
  'ad-loaded',
  'ad-delayed',
  'ad-failed',
  'ad-dismissed',
  'ad-closed',
  'ad-initialized',
  'ad-impression',
]

const blacklistedMoEngageEvents = [
  EventType.DesktopAdSelected,
  EventType.DesktopAdError,
  EventType.DesktopAdFilled,
  EventType.DesktopAdNoFill,
  EventType.DesktopAdRequested,
  EventType.DesktopAdShown,
  EventType.MobileAdSelected,
  EventType.MobileAdError,
  EventType.MobileAdFilled,
  EventType.MobileAdNoFill,
  EventType.MobileAdRequested,
  EventType.MobileAdShown,
  ...blacklistedAdsEvents,
]

const GAMEZOP_GTAG_ID = 'G-R68FH2QNBT'

const PARTNER_GTAG_IDS_GROUP_NAME = 'publishers'

export {EventKey, blacklistedMoEngageEvents, GAMEZOP_GTAG_ID, PARTNER_GTAG_IDS_GROUP_NAME}
